import Tv from "../../assets/imgProducts/tv.png";
import CheckedCircle from "../../assets/checked-circle.svg";
import { CarouselPrimary } from "../../components/Carousel";
import { PurchaseDetails } from "../../components/PurchaseDetails";
import Vinho from "../../assets/zkp/vinho.svg";

import {
  Products,
  SuccessfulPurchaseContent,
  SuccessfulPurchaseContainer,
} from "./style";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearCardSuccess } from "../../store/cart/addCart";

const purchaseSummary = [
  process.env.REACT_APP_ZKP === "true"
    ? {
        id: 1,
        productName: "Vinho Tinto Suave 750ml Uvas Campestres",
        productPrice: "150.00",
        img: Vinho,
        productCode: "Cód: 00000000000",
        productBrand: "Uvas Campestres",
      }
    : {
        id: 1,
        productName: "Televisão OLED Super Digital 42”",
        productPrice: "2.099,00",
        img: Tv,
        productCode: "00000000000",
        productBrand: "Super Digital",
      },
];

const credentialProofData = {
  protocol: "0000000000000",
  summary: purchaseSummary,
  status: "success",
};

export function SuccessfulPurchase() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearCardSuccess(0));
    sessionStorage.removeItem("session");
  }, [dispatch]);

  return (
    <SuccessfulPurchaseContainer>
      <SuccessfulPurchaseContent>
        <div className="contentItems">
          <h2 className="successfulPurchase">
            Compra realizada com sucesso{" "}
            <img
              className="checkedCircle"
              src={CheckedCircle}
              alt="checked circle"
            />
          </h2>
          <h3 className="processedPurchase">
            Sua compra foi processada e seu protocolo é:{" "}
            {credentialProofData.protocol}
          </h3>
          <PurchaseDetails
            key={credentialProofData.id}
            {...credentialProofData}
          />
        </div>
        <Products>
          <h2 className="textTitle">
            Também se interessam <span>Ver mais produtos</span>
          </h2>
          <CarouselPrimary />
        </Products>
      </SuccessfulPurchaseContent>
    </SuccessfulPurchaseContainer>
  );
}
